import React from 'react';

import useFlag, { FLAGS } from '@rover/shared/js/hooks/useFlag';

import PaginationWrapper from '../PaginationWrapper';

import type { Props as SnappingCarouselV1Props } from './v1';
import SnappingCarouselV1 from './v1';
import type { Props as SnappingCarouselV2Props } from './v2';
import SnappingCarouselV2 from './v2';

/**
 * This is a temporary junction where we control which version of the SnappingCarousel is being used. Once the rollout is complete, we will remove this logic along with SnappingCarouselV1
 */
const SnappingCarousel: React.FC<SnappingCarouselV1Props | SnappingCarouselV2Props> = ({
  children,
  onScroll,
  ...props
}) => {
  const useSnappingCarouselV2 = useFlag(FLAGS.ROLLOUT_SNAPPINGCAROUSEL_V2);

  if (useSnappingCarouselV2) {
    return (
      <PaginationWrapper {...props}>
        <SnappingCarouselV2 onScroll={onScroll}>{children}</SnappingCarouselV2>
      </PaginationWrapper>
    );
  }
  return (
    <SnappingCarouselV1 {...props}>
      {React.Children.toArray(children).filter((child) => React.isValidElement(child))}
    </SnappingCarouselV1>
  );
};

export default SnappingCarousel;
